/**
 * Validação matemática de CPF (Cadastro de Pessoas Físicas)
 * @param cpf String contendo o CPF (com ou sem formatação)
 * @returns true se válido, false caso contrário
 */
export function isValidCPF(cpf: string): boolean {
  if (!cpf) return false;

  // Remove caracteres não numéricos
  const cleanCpf = cpf.replace(/\D/g, '');

  // Verificações básicas de tamanho e números repetidos
  if (cleanCpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cleanCpf)) return false;

  // Validação dos dígitos verificadores
  const calcDigit = (slice: string, factor: number): number => {
    let sum = 0;
    for (const char of slice) {
      sum += parseInt(char) * factor--;
    }
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };

  const digit1 = calcDigit(cleanCpf.slice(0, 9), 10);
  const digit2 = calcDigit(cleanCpf.slice(0, 10), 11);

  return (
    digit1 === parseInt(cleanCpf.charAt(9)) &&
    digit2 === parseInt(cleanCpf.charAt(10))
  );
}

/**
 * Validação matemática de CNPJ (Cadastro Nacional da Pessoa Jurídica)
 * @param cnpj String contendo o CNPJ (com ou sem formatação)
 * @returns true se válido, false caso contrário
 */
export function isValidCNPJ(cnpj: string): boolean {
  if (!cnpj) return false;

  // Remove caracteres não numéricos
  const cleanCnpj = cnpj.replace(/\D/g, '');

  // Verificações básicas de tamanho e números repetidos
  if (cleanCnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cleanCnpj)) return false;

  // Validação dos dígitos verificadores
  // Algoritmo:
  // Pesos: 5,4,3,2,9,8,7,6,5,4,3,2
  const calcDigit = (slice: string, weights: number[]): number => {
    let sum = 0;
    for (let i = 0; i < slice.length; i++) {
      sum += parseInt(slice[i]) * weights[i];
    }
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const digit1 = calcDigit(cleanCnpj.slice(0, 12), weights1);
  const digit2 = calcDigit(cleanCnpj.slice(0, 13), weights2);

  return (
    digit1 === parseInt(cleanCnpj.charAt(12)) &&
    digit2 === parseInt(cleanCnpj.charAt(13))
  );
}

